import React from "react";
import { Tag, Tooltip } from "antd";
import styled from "styled-components";
import { formatStaleDuration } from "../services/orderOperationalStatus.js";

const HEALTH_CONFIG = {
  onTrack: { color: "success", label: "On Track" },
  attention: { color: "warning", label: "Attention" },
  delayed: { color: "error", label: "Delayed" },
  blocked: { color: "error", label: "Blocked" },
};

const ChipWrap = styled.span`
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
`;

const StaleNote = styled.span`
  font-size: 11px;
  color: #8c8c8c;
  line-height: 1.2;
`;

const NaText = styled.span`
  font-size: 13px;
  color: #bfbfbf;
`;

/**
 * @param {{
 *   health: "onTrack"|"attention"|"delayed"|"blocked"|null,
 *   reason?: string,
 *   hoursSinceUpdate?: number|null,
 *   staleUpdateHours?: number,
 *   applicable?: boolean,
 * }} props
 */
export default function DeliveryHealthChip({
  health = null,
  reason = "",
  hoursSinceUpdate = null,
  staleUpdateHours = 12,
  applicable = true,
}) {
  if (!applicable || health == null) {
    return <NaText>—</NaText>;
  }

  const config = HEALTH_CONFIG[health] || HEALTH_CONFIG.onTrack;
  const staleLabel = formatStaleDuration(hoursSinceUpdate);
  const showStale =
    health !== "onTrack" &&
    hoursSinceUpdate != null &&
    hoursSinceUpdate >= staleUpdateHours &&
    staleLabel;

  return (
    <ChipWrap>
      <Tooltip title={reason || config.label}>
        <Tag color={config.color} style={{ margin: 0 }}>
          {config.label}
        </Tag>
      </Tooltip>
      {showStale && <StaleNote>No update for {staleLabel}</StaleNote>}
    </ChipWrap>
  );
}
